import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { SearchResultBeket } from 'widgets/beket/beket-search-result'

import findTicketStore from 'entities/beket/models/find-ticket/find-ticket-store'

const SearchResultBeketPage = observer(() => {
  const navigate = useNavigate()

  const formFindTicket = toJS(findTicketStore.formFindTicket)

  useEffect(() => {
    const direction = formFindTicket?.directions?.[0]

    !direction?.date && navigate(RoutingPaths.path())
  }, [])

  return <SearchResultBeket findFormBeket={formFindTicket} />
})

export default SearchResultBeketPage
